module.exports = (__webpack_require__(7))(1518);